<template>
  <modal closeMutation="HIDE_SUCCESS_MODAL" v-if="isSuccessModalVisible" class="modal_success_action">
    <div class="success_message">
      <div class="icon">
        <img src="../assets/img/tick_circle.svg">
      </div>
      <p>{{ successMessage }}</p>
    </div>
  </modal>
</template>

<script>
import Modal from '@/views/Modal.vue';
import {mapGetters} from 'vuex';

export default {
  name: 'SuccessModal',
  components: {Modal},
  computed: {
    ...mapGetters(['successModal', 'successMessage']),
    isSuccessModalVisible() {
      return this.successModal;
    }
  },
  methods: {
    hideModal() {
      this.$store.commit('HIDE_SUCCESS_MODAL');
    }
  }
};
</script>
